import { FIELD_PATHS, GuarantorRelationshipType, RELATIONSHIP_TYPE_OPTIONS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { ApplicantEntityIndex } from '@funnels/types';

import { DropdownField } from '../../Fields/';

interface GuarantorRelationshipProps extends ApplicantEntityIndex {
  borrowerFirstName: string;
}

export const GuarantorRelationship = (props: GuarantorRelationshipProps) => {
  const { applicantIndex, borrowerFirstName, ...rest } = props;
  const [formValues, setFormValue] = useFormValues();

  const handleOnChange = ([selectedValue]: string[]) => {
    //reset GuarantorRelationshipDescription
    if (
      selectedValue !== GuarantorRelationshipType.OTHER &&
      selectedValue !== GuarantorRelationshipType.OTHER_RELATIVE
    ) {
      setFormValue(FIELD_PATHS.APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER_TYPE_OTHER(applicantIndex), undefined);
    }
  };

  return (
    <DropdownField
      {...rest}
      name={FIELD_PATHS.APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER_TYPE(applicantIndex)}
      label={`Relationship to ${borrowerFirstName}`}
      options={RELATIONSHIP_TYPE_OPTIONS}
      onChange={handleOnChange}
    />
  );
};
